import { Component } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AnimationOptions } from 'ngx-lottie';
import { BaseFormDirective } from 'src/app/directives/base-form.directive';
import { AuthService } from 'src/app/services/auth/auth.service';

import CryptoJS from 'crypto-js';
import { UtilsService } from 'src/app/services/utils/utils.service';


@Component({
  selector: 'app-new-password',
  templateUrl: './new-password.component.html',
  styleUrls: ['./new-password.component.sass']
})
export class NewPasswordComponent {

  title = 'AUTH.PASSWORD-RECOVER'
  processing = false

  options: AnimationOptions = {
    path: '/assets/animations/loading.json',
  }

  data = null

  signInForm = new FormGroup({

    password: new FormControl('', [Validators.required, Validators.minLength(8)]),
    repeat_password: new FormControl('', [Validators.required, Validators.minLength(8), this.passwordMatchValidator('password')])

  })

  constructor(
    private auth: AuthService,
    private router: Router,
    protected route: ActivatedRoute,
    public utils: UtilsService
  ) {
    this.route.params.subscribe(params => {
      if ('data' in params) {
        this.data = params['data']
        console.log(this.data)
      }
    })
  }

  ChangePassword() {
    this.processing = true

    let form = {
      ...this.signInForm.value,
      data: this.data
    }


    this.auth.authRecover(form).subscribe(
      (data) => {

        this.processing = false;
        this.utils.toast.saved(this.title)
        this.router.navigateByUrl('/auth/sign-in');
      },
      (error) => {

        this.utils.toast.error(error.error.error)
        this.processing = false;
      }
    );


  }







  passwordMatchValidator(passwordControlName: string): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.parent) return null;

      const password = control.parent.get(passwordControlName)?.value;
      const confirmPassword = control.value;

      return password === confirmPassword ? null : { passwordMismatch: true };
    };
  }







}
